import { render, staticRenderFns } from "./AboutBrandsSection.vue?vue&type=template&id=27052bbc&scoped=true&"
import script from "./AboutBrandsSection.vue?vue&type=script&lang=js&"
export * from "./AboutBrandsSection.vue?vue&type=script&lang=js&"
import style0 from "./AboutBrandsSection.vue?vue&type=style&index=0&id=27052bbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27052bbc",
  null
  
)

export default component.exports